import { render, staticRenderFns } from "./NavBarUser.vue?vue&type=template&id=3d112187&scoped=true&"
import script from "./NavBarUser.vue?vue&type=script&lang=js&"
export * from "./NavBarUser.vue?vue&type=script&lang=js&"
import style0 from "./NavBarUser.vue?vue&type=style&index=0&id=3d112187&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d112187",
  null
  
)

export default component.exports